import { onBeforeMount, watch } from 'vue'
import { cloneDeep } from 'lodash'

let bodyCss = ''
let listCssMap = {}

// 样式单位白名单
export const CSS_STYLE_UNIT_WHITE_LIST = [
  'width',
  'height',
  'top',
  'left',
  'bottom',
  'marginTop',
  'marginLeft',
  'marginRight',
  'marginBottom',
  'borderWidth',
  'paddingTop',
  'paddingBottom',
  'paddingRight',
  'paddingLeft',
  'letterSpacing',
  'fontSize',
  '-webkitTextStrokeWidth'
]

/**
 * 样式对象装css字符串
 * @param {*} style
 * @returns
 */
const styleToString = (style) => {
  if (!style) return ''
  let s = cloneDeep(style)
  if (import.meta.env.VITE_APP_TAG !== 'H5') {
    s = formatterStyleByEditer(s)
  } else {
    s = formatterStyleByPhone(s)
  }
  // prettier-ignore
  return Object.keys(s).reduce((acc, key) => acc + key.split(/(?=[A-Z])/).join('-').toLowerCase() + ':' + s[key] + ';', '')
}

const formatNumber = (num) => {
  if (Number.isInteger(num)) {
    return num
  } else {
    return num.toFixed(1)
  }
}

/**
 * 根据屏幕高度与节点高度计算垂直居中定位（设计稿单位，基准宽 750）
 * @param {*} style 节点样式
 * @param {*} screenWidth 屏幕宽度 px
 * @param {*} screenHeight 屏幕高度 px
 */
export const calcCenterPosition = (style, screenWidth, screenHeight) => {
  const updates = {}
  if (style.centerVertical) {
    const ratio = screenWidth / 750
    const height = Number(style.height) || 0
    updates.top = formatNumber((screenHeight / ratio - height) / 2)
  }
  return updates
}

/**
 * 应用居中定位并移除配置项
 * @param {*} s 样式对象
 */
const applyCenterPosition = (s) => {
  const screenWidth = window.innerWidth || 750
  const screenHeight = window.innerHeight || 1334
  const updates = calcCenterPosition(s, screenWidth, screenHeight)
  if (updates.top !== undefined) {
    s.top = updates.top
    delete s.bottom
  }
  delete s.centerHorizontal
  delete s.centerVertical
}

/**
 * 手机单位适配
 * @param {*} style
 */
const formatterStyleByPhone = (style) => {
  // 样式单位适配
  const contentWeight = window.innerWidth || 750
  const ratio = contentWeight / 750
  const s = cloneDeep(style)
  applyCenterPosition(s)
  for (let key in s) {
    if (CSS_STYLE_UNIT_WHITE_LIST.includes(key)) {
      // 针对自由布局内部组件，底部距离需要特殊处理
      if (key === 'bottom' && (s[key] || s[key] === 0)) {
        const num = formatNumber(s[key] * ratio)
        s[key] = `${num}px`
        continue
      }
      if (s[key] === 0 || s[key] === '0' || !s[key]) {
        delete s[key]
      } else {
        const num = formatNumber(s[key] * ratio)
        s[key] = `${num}px`
      }
    }
  }

  if (s.backgroundImage) {
    s.backgroundImage = `url('${s.backgroundImage}')`
    s.backgroundSize = '100% 100%'
    s.backgroundRepeat = 'no-repeat'
  }

  if (s.borderRadius) {
    // s.borderRadius = `${s.borderRadius}rem`
    const num = formatNumber(s.borderRadius * ratio)
    s.borderRadius = `${num}px`
    s.overflow = 'hidden'
  }

  if (s.rotate) s.transform = `rotate(${s.rotate}deg)`
  return s
}

/**
 * 浏览器单位适配
 * @param {*} style
 */
const formatterStyleByEditer = (s) => {
  delete s.centerHorizontal
  delete s.centerVertical
  // 样式单位适配
  for (let key in s) {
    if (CSS_STYLE_UNIT_WHITE_LIST.includes(key)) {
      if (s[key] === 0 || s[key] === '0' || !s[key]) {
        delete s[key]
      } else {
        s[key] = `${s[key]}px`
      }
    }
  }

  if (s.backgroundImage) {
    s.backgroundImage = `url('${s.backgroundImage}')`
    s.backgroundSize = '100% 100%'
    s.backgroundRepeat = 'no-repeat'
  }

  if (s.borderRadius) {
    s.borderRadius = `${s.borderRadius}px`
    s.overflow = 'hidden'
  }

  if (s.rotate) s.transform = `rotate(${s.rotate}deg)`

  // 编辑器固定定位样式，由容器去控制
  s.top = 0
  s.left = 0
  s.marginTop = 0
  s.marginLeft = 0
  s.marginBottom = 0
  s.marginRight = 0
  s.position = 'relative'
  return s
}

/**
 * 添加新的字符串样式
 * @param {*} newStyle
 */
const addCss = (newStyle) => {
  const firstStyle = document.body.getElementsByTagName('style')[0]
  firstStyle.innerHTML = `${bodyCss}${newStyle}`
  bodyCss = firstStyle.innerHTML
}

/**
 * 跟换样式
 * @param {*} id 组件id
 * @param {*} style 组件样式
 */
const changeCss = (id, style) => {
  const newString = styleToString(style)
  const regex = new RegExp(`#${id}\\{.*?\\}`, 'g')
  const result = bodyCss.replace(regex, `#${id}{${newString}}`)
  const firstStyle = document.body.getElementsByTagName('style')[0]
  firstStyle.innerHTML = `${result}`
  bodyCss = result
}

/**
 * 添加列表样式
 * @param {*} classUUID
 * @param {*} style
 */
export const addListCss = (classUUID, style) => {
  if (!listCssMap[classUUID]) {
    // 未生成样式
    const styleStr = styleToString(style)
    const idCss = `.list-layout.${classUUID}{${styleStr}}`
    addCss(idCss)
    listCssMap[classUUID] = true
    // console.log('列表样式添加', classUUID)
  }
}

/**
 * 初始化组件样式
 * @param {*} id 组件id
 * @param {*} style 组件样式
 */
export const initComponentCss = (id, style, name, listIndex) => {
  // 编辑器需实时监听样式变化
  if (import.meta.env.VITE_APP_TAG !== 'H5') {
    watch(
      () => style,
      () => {
        changeCss(id, style.value)
      },
      {
        deep: true
      }
    )
  }
  onBeforeMount(() => {
    if (listIndex) {
      // 列表组件样式处理，不重新生成样式
      addListCss(id, style.value)
    } else if (name !== 'xy-list-item-layout') {
      const styleStr = styleToString(style.value)
      const idCss = `#${id}{${styleStr}}`
      addCss(idCss)
    }
  })
}
